(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["24k-next-drop"] && !Shopify.designMode) return;
  try {
    

if(!customElements.get('k24-countdown')){customElements.define('k24-countdown',class extends HTMLElement{connectedCallback(){this.end=Date.parse(this.dataset.end);this.tick();this.timer=setInterval(()=>this.tick(),1000)}disconnectedCallback(){clearInterval(this.timer)}tick(){const count=this.querySelector('.k24-count');const status=this.querySelector('.k24-ended');if(!Number.isFinite(this.end)){count.hidden=true;return}const remaining=Math.max(0,Math.floor((this.end-Date.now())/1000));const values=[Math.floor(remaining/86400),Math.floor(remaining%86400/3600),Math.floor(remaining%3600/60),remaining%60];this.querySelectorAll('.k24-value').forEach((el,i)=>el.textContent=String(values[i]).padStart(2,'0'));count.hidden=remaining===0;status.hidden=remaining!==0}})}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
